const invoiceCheckbox = document.querySelector(".js-invoice-address");
const deliveryWrapper = document.querySelector(".js-delivery-address");

if (invoiceCheckbox) {
	invoiceCheckbox.addEventListener('change', function (e) {
		deliveryWrapper.style.display = 'block';
		if (e.target.checked) {
			deliveryWrapper.style.display = 'none';
		}
	})
}
